
























import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { client } from '../../store';
import { IPageParams, IDocument } from '../../models';
import { getUserFullName } from '@/helpers/functions';
const ns = { namespace: 'document' };
import paginationMixin from '@/mixins/pagintation';
@Component({
  methods: {
    getUserFullName,
  },
  components: {
    UIActions: () => import('@/components/UI/Actions.vue'),
  },
  data: () => ({
    namespace: 'document',
  }),
  mixins: [paginationMixin],
})
export default class DocumentList extends Vue {
  @Action('getEntities', ns) getEntities: () => void;
  @Getter('entitiesSlice', ns) entitiesSlice: IDocument[];
  @State('pageParams', ns) pageParams: IPageParams;
  selected = [];
  interval = null;
  headers = [
    { text: 'Название', value: 'name' },
    { text: 'Автор', value: 'creator' },
    { text: 'Время создания', value: 'created_at' },
  ];
  mounted() {
    this.getEntities();
  }
}
